import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU.TEXT',
    isTitle: true
  },
  {
    id: 2,
    label: 'MENUITEMS.DASHBOARD.TEXT',
    icon: 'bx bxs-dashboard',
    link: '/'
  },
  {
    id: 3,
    label: 'MENUITEMS.PRODUCT',
    icon: 'bx bxs-devices',
    link: '/products/list'
  },
  {
    id: 4,
    label: 'MENUITEMS.CUSTOMERS',
    icon: 'bx bxs-buildings',
    link: '/customers/list'
  }
];
